var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SsoManager } from "@jawbreaker/auth-sso";
import { Status } from "@jawbreaker/auth-status";
import React from "react";
import { LoggedInUserBadge, LoggedOutUserBadge, PendingUserBadge, } from "./Components";
var handleLogout = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var existingPopup, observer_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                existingPopup = document.querySelector('pip-log-out-popup');
                if (existingPopup) {
                    existingPopup.remove();
                }
                observer_1 = new MutationObserver(function (mutations) {
                    // Find the newly added popup in the DOM
                    var popup = document.querySelector('pip-log-out-popup');
                    var checkForContent = setInterval(function () {
                        // Access the shadow DOM and look for the main popup container
                        var shadowRoot = popup === null || popup === void 0 ? void 0 : popup.shadowRoot;
                        var ssoPopup = shadowRoot === null || shadowRoot === void 0 ? void 0 : shadowRoot.querySelector('.sso-pop-up');
                        if (ssoPopup) {
                            // Find all focusable elements within the shadow DOM
                            var focusableElements = ssoPopup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                            if (focusableElements.length > 0) {
                                // Set up focus trap between first and last focusable elements
                                var firstFocusable_1 = focusableElements[0];
                                firstFocusable_1.focus();
                                var lastFocusable = focusableElements[focusableElements.length - 1];
                                lastFocusable.addEventListener('keydown', function (e) {
                                    if (e.key === 'Tab') {
                                        e.preventDefault();
                                        firstFocusable_1.focus();
                                    }
                                });
                            }
                            // Cleanup once we've set up the focus trap
                            clearInterval(checkForContent);
                            observer_1.disconnect();
                        }
                    }, 100);
                    // Safety cleanup: clear both interval and observer if popup content isn't found within 5 seconds
                    setTimeout(function () {
                        clearInterval(checkForContent);
                        observer_1.disconnect();
                    }, 5000);
                });
                // Start watching for popup to be added to the DOM
                observer_1.observe(document.body, {
                    childList: true,
                    subtree: true
                });
                return [4 /*yield*/, SsoManager.triggerLogoutPopup(email)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error("Error in handleLogout:", error_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var UserBadge = function (_a) {
    var authState = _a.authState, className = _a.className, setHamburgerOpen = _a.setHamburgerOpen, hamburgerOpen = _a.hamburgerOpen;
    return Status.fold({
        pending: function () { return React.createElement(PendingUserBadge, { className: className }); },
        loggedOut: function () { return (React.createElement(LoggedOutUserBadge, { className: className, setHamburgerOpen: setHamburgerOpen, hamburgerOpen: hamburgerOpen })); },
        loggedIn: function (data) { return (React.createElement(LoggedInUserBadge, { onClick: function () { return handleLogout(data.email); }, greeting: Status.getGreeting(data), className: className, setHamburgerOpen: setHamburgerOpen, hamburgerOpen: hamburgerOpen })); },
    }, authState);
};
